<template>
  <RouterLink :to="{ name: 'client-news' }" class="flex items-end">
    <AdvancedTooltip
        theme="blue"
        placement="top"
        title="Customers Users News Page">
      <div class="relative">
        <IconClientNews class="-mb-2 mr-0.5"/>
        <span v-if="hasNews"
              class="absolute text-white bg-red-500 text-[9px] w-[35px] h-[13px] px-1 rounded cursor-pointer flex justify-center">NEWS</span>
      </div>
    </AdvancedTooltip>
  </RouterLink>
</template>

<script setup lang="ts">
import IconClientNews from "@/components/svg_icons/IconClientNews.vue";
import AdvancedTooltip from "@/components/tooltip/AdvancedTooltip.vue";

const props = defineProps({
  hasNews: {
    type: Boolean,
    required: true
  }
})
</script>